import { Link } from "react-router-dom";
import { motion } from "framer-motion";
import { ArrowUpRight } from "lucide-react";
import { useTranslation } from "react-i18next";
import { getSiblings } from "../lib/products";

const CrossSell = ({ slug }) => {
  const { t } = useTranslation();
  const siblings = getSiblings(slug);

  return (
    <section className="mx-auto max-w-7xl px-5 md:px-8 py-24 md:py-32" data-testid="cross-sell">
      <p className="text-[10px] md:text-xs font-bold uppercase tracking-[0.24em] text-muted-foreground">
        {t("product.crossSellTitle")}
      </p>
      <div className="mt-8 grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-4">
        {siblings.map((p, i) => {
          const Icon = p.icon;
          return (
            <motion.div
              key={p.slug}
              initial={{ opacity: 0, y: 24 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true, margin: "-60px" }}
              transition={{ duration: 0.5, delay: i * 0.06 }}
            >
              <Link
                to={`/${p.slug}`}
                className="group block rounded-2xl border border-foreground/10 bg-foreground/[0.02] hover:bg-foreground/[0.05] p-6 transition"
                data-testid={`cross-sell-${p.slug}`}
              >
                <div
                  className="flex h-12 w-12 items-center justify-center rounded-xl"
                  style={{
                    background: `${p.accentColor}1f`,
                    boxShadow: `inset 0 0 0 1px ${p.accentColor}55`,
                  }}
                >
                  <Icon className="h-6 w-6 text-white" strokeWidth={1.6} />
                </div>
                <p className="mt-6 font-display text-xl">{p.name}</p>
                <p className="mt-1 text-sm text-muted-foreground line-clamp-2">{t(`products.${p.slug}.tagline`)}</p>
                <p
                  className="mt-6 inline-flex items-center gap-1 text-xs font-semibold"
                  style={{ color: p.accentColor }}
                >
                  {t("solutions.learnMore")}
                  <ArrowUpRight className="h-3.5 w-3.5 transition-transform group-hover:translate-x-0.5 group-hover:-translate-y-0.5" />
                </p>
              </Link>
            </motion.div>
          );
        })}
      </div>
    </section>
  );
};

export default CrossSell;
